import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Crown, BarChart, Trophy, BookOpen } from 'lucide-react';

interface TabsProps {
  // Rimuoviamo activeTab e onTabChange perché ora usiamo l'URL
}

const Tabs: React.FC<TabsProps> = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    return location.pathname === path;
  };

  return (
    <div className="w-full mb-4 md:mb-8">
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
        <Link 
          to="/" 
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 border-2 rounded-lg transition-all duration-200 ${
            isActive('/') 
              ? 'border-terminal-green bg-terminal-green/10 text-terminal-green' 
              : 'border-terminal-green/30 text-terminal-green/70 hover:border-terminal-green/50 hover:text-terminal-green'
          }`}
        >
          <Crown size={18} />
          <span className="font-medium">Gioca</span>
        </Link>
        
        <Link 
          to="/scores" 
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 border-2 rounded-lg transition-all duration-200 ${
            isActive('/scores') 
              ? 'border-terminal-green bg-terminal-green/10 text-terminal-green' 
              : 'border-terminal-green/30 text-terminal-green/70 hover:border-terminal-green/50 hover:text-terminal-green'
          }`}
        >
          <Trophy size={18} />
          <span className="font-medium">Punteggi</span>
        </Link>
        
        <Link 
          to="/benchmarks" 
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 border-2 rounded-lg transition-all duration-200 ${
            isActive('/benchmarks') 
              ? 'border-terminal-green bg-terminal-green/10 text-terminal-green' 
              : 'border-terminal-green/30 text-terminal-green/70 hover:border-terminal-green/50 hover:text-terminal-green'
          }`}
        >
          <BarChart size={18} />
          <span className="font-medium">Benchmark</span>
        </Link>

        <Link 
          to="/storia" 
          className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 border-2 rounded-lg transition-all duration-200 ${
            isActive('/storia') 
              ? 'border-terminal-green bg-terminal-green/10 text-terminal-green' 
              : 'border-terminal-green/30 text-terminal-green/70 hover:border-terminal-green/50 hover:text-terminal-green'
          }`}
        >
          <BookOpen size={18} />
          <span className="font-medium">Storia</span>
        </Link>
      </div>
    </div>
  );
};

export default Tabs;